module.exports = __webpack_public_path__ + "img/中国科学技术大学logo.fd8f33c6.png";